// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-kaleidoscope-js": () => import("./../../../src/pages/kaleidoscope.js" /* webpackChunkName: "component---src-pages-kaleidoscope-js" */),
  "component---src-pages-rocket-sauce-js": () => import("./../../../src/pages/rocket-sauce.js" /* webpackChunkName: "component---src-pages-rocket-sauce-js" */),
  "component---src-pages-thesedays-js": () => import("./../../../src/pages/thesedays.js" /* webpackChunkName: "component---src-pages-thesedays-js" */),
  "component---src-pages-think-ewe-js": () => import("./../../../src/pages/think-ewe.js" /* webpackChunkName: "component---src-pages-think-ewe-js" */)
}

